<template>
  <el-select v-model="dd"
             :multiple="multiple"
             :placeholder="hints"
             :disabled="disabled"
             :filterable="true"
             :allow-create="allowCreate"
             size="small">
    <el-option v-for="item in options"
               :key="item.value"
               :label="item.display"
               :value="item.value">
      <span style="float: left">{{ item.display }}</span>
      <span :style="'float: right; color: #8492a6; font-size: 13px;' + (multiple ? ' margin-right: 20px':'')">{{ item.value }}</span>
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "ProductItemSelectOptions",
  props: {
    value: [Number, String, Array],
    options: Array,
    multiple: Boolean,
    hints: String,
    disabled: Boolean,
    allowCreate: Boolean
  },
  computed: {
    dd: {
      get: function () {
        return !(this.value === null || this.value === undefined) ? this.value : (this.multiple ? [] : null)
      },
      set: function (n) {
        this.$emit('input', n)
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
